module.exports = __webpack_public_path__ + "img/Threads.cff8ef45.svg";